<template>
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="formDisabled">
        <a-form-model ref="form" :model="model" :label-col="labelCol2" :wrapper-col="wrapperCol2"  :rules="validatorRules" slot="detail">
          <a-row>
             <a-col :span="12">
              <a-form-model-item :label="this.language['cs.person.personid']"  prop="personid">
                <a-input v-model="model.personid" :disabled="operation.visible"  :placeholder="this.language['cs.person.personid']" maxLength="50" ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="this.language['cs.person.pname']"  prop="pname">
                <a-input v-model="model.pname" :placeholder="this.language['cs.person.pname']" maxLength="50" ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="this.language['cs.person.sex']"  prop="sex">
                <!-- <a-input v-model="model.sex" :placeholder="this.language['cs.person.sex']" ></a-input> -->
                <a-Select  v-model="model.sex" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.person.sex']"  >
                <a-select-option value="M">男</a-select-option>
                <a-select-option value="F">女</a-select-option>
              </a-Select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="this.language['cs.person.jobname']"  prop="jobname">
                <a-input v-model="model.jobname" :placeholder="this.language['cs.person.jobname']" maxLength="50" ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="this.language['cs.person.deptname']"  prop="deptname">
                <a-input v-model="model.deptname" :placeholder="this.language['cs.person.deptname']" maxLength="50" ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="this.language['cs.person.phone']"  prop="phone">
                <a-input v-model="model.phone" :placeholder="this.language['cs.person.phone']" maxLength="50" ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="this.language['cs.person.email']"  prop="email">
                <a-input v-model="model.email" :placeholder="this.language['cs.person.email']" maxLength="50" ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="this.language['cs.person.workno']"  prop="workno">
                <a-input v-model="model.workno" :placeholder="this.language['cs.person.workno']" maxLength="50" ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-show="isShow">
              <a-form-model-item :label="this.language['cs.activity.activityname']"  prop="sysactivityid">
                <a-Select  v-model="model.sysactivityid" :disabled="operation.visible"  @change="handChageActivity" :options="selectActivityList" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.activity.activityname']"  >
              </a-Select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-show="isShow">
              <a-form-model-item :label="this.language['cs.venue.venuename']"  prop="sysvenueid">
                <a-Select  v-model="model.sysvenueid" :options="selectVenueList" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.venue.venuename']"  >
              </a-Select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="this.language['cs.seatgroup.sgroupname']"  prop="syspgid">
                <a-Select  v-model="model.syspgid" :options="selectPgList" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.seatgroup.sgroupname']"  >
              </a-Select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label-col="labelCol1" :wrapper-col="wrapperCol1" :label="this.language['cs.person.sourcedesc']"  prop="sourcedesc">
                <a-input v-model="model.sourcedesc" :placeholder="this.language['cs.person.sourcedesc']" maxLength="50" ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label-col="labelCol1" :wrapper-col="wrapperCol1"  :label="this.language['cs.remark']"  prop="remark">
                <a-input v-model="model.remark" :placeholder="this.language['cs.remark']" maxLength="150" ></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </template>
  
  
  <script>
  
  import {validateDuplicateValue} from '@/utils/util'
  import { httpAction, getAction } from '@/api/manageChooseSeat'
  import moment from 'moment'
  
  export default {
    name: 'PersonForm',
    inject:['dataActivity','operation'],
    components: {},
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        model: {},
        uploadSource:"chooseseat",
      // form 一行布局
      labelCol1: { span: 4 },
      wrapperCol1: { span: 18 },
      // form 两行布局， 默认为两行
      labelCol2: { span: 8 },
      wrapperCol2: { span: 12 },
        confirmLoading: false,
        url: {
          add: "/PersonInfo/add",
          edit: "/PersonInfo/edit"
        },
        isShow:true,
        selectActivityList:[],
        selectPgList:[],
        selectVenueList:[]
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      formDisabled() {
        return this.disabled
      },
      validatorRules() {
        if (this.language) {
          return {
            personid: [
              {required: true, message: this.language['cs.input']+this.language['cs.person.personid']+'!'}
            ],
            pname: [
              {required: true, message: this.language['cs.select']+this.language['cs.person.pname']+'!'}
            ],
            // sex: [
            //   {required: true, message: this.language['cs.select']+this.language['cs.person.sex']+'!'}
            // ],
            sysactivityid: [
              {required: true, message: this.language['cs.select']+this.language['cs.activity.activityname']+'!'}
            ],
            syspgid: [
              {required: true, message: this.language['cs.select']+this.language['cs.persongroup.pgroupname']+'!'}
            ]
          }
        }
      }
  
    },
    created() {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      if(this.dataActivity!=null)
        {
         this.isShow=this.dataActivity.isShow;
         this.$set( this.model, 'sysactivityid', this.dataActivity.sysactivityid);
        }
      // if(this.operation!=null)
      //   {
      //     alert(this.operation.sysactivityid)
      //     this.$set( this.model, 'sysactivityid', this.operation.sysactivityid); 
      //   }
      this.loadSelectData();
    },
    mounted(){
      },
      watch: {
        'model.sysactivityid':function (val) {
                if (val) {
                  this.selectPgList=[];
                  let selectparams = { keytype: "sgroup", parentid:val};   
                    getAction('/SelectData/SelectDataList', selectparams).then((res) => {
                      if (res.success) {
                        this.selectPgList= res.result.records;
                      }
                  }); 

                  this.selectVenueList=[];
                 let selectVenueparams= { keytype: "activity_venue", parentid:val};  
                  getAction('/SelectData/SelectDataList', selectVenueparams).then((res) => {
                  if (res.success) {
                    this.selectVenueList= res.result.records;
                  }
                  if(this.dataActivity!=null)
                    {
                    this.$set( this.model, 'sysvenueid', this.dataActivity.sysvenueid);
                    }
                   }); 
                } 
                else {
                  this.selectPgList=[];
                  this.selectVenueList=[];
                }
              }
    },
    methods: { 
      loadSelectData() { 
     
          this.selectActivityList=[];;  
          let selectvenue= { keytype: "activity", parentid:"",curvalue:this.model.sysactivityid};  
           getAction('/SelectData/SelectDataList', selectvenue).then((res) => {
          if (res.success) {
            this.selectActivityList= res.result.records;
          }
      });  
      
      // this.selectPgList=[];  
      //     let selectparams= { keytype: "sgroup", parentid:this.model.sysactivityid,curvalue:this.model.syspgid};  
      //      getAction('/SelectData/SelectDataList', selectparams).then((res) => {
      //     if (res.success) {
      //       this.selectPgList= res.result.records;
      //       console.log(" this.selectPgList===", this.selectPgList)
      //     }
      // });  
     
      // this.selectVenueList=null;
      // let selectVenueparams= { keytype: "activity_venue", parentid:this.model.sysactivityid,curvalue:this.model.sysvenueid};  
      //      getAction('/SelectData/SelectDataList', selectVenueparams).then((res) => {
      //     if (res.success) {
      //       this.selectVenueList= res.result.records;
      //     }
      // }); 
      },
      add() {
        this.edit(this.modelDefault);   
        if(this.dataActivity!=null)
        {
         this.$set( this.model, 'sysactivityid', this.dataActivity.sysactivityid);
        }
      },
      edit(record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      handChageActivity(){
        this.$set(this.model,"sysvenueid","");
        this.$set(this.model,"syspgid","");

      },
      submitForm() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
  
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.sysid) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
  
        })
      },
   
    }
  }
  
  
  </script>